var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('div',{staticClass:"nav"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("担当一覧")]),_c('v-spacer'),_c('v-btn',{on:{"click":_vm.logout}},[_vm._v("ログアウト")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }